import { CircularProgress, IconButton } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import { s3baseUrl } from "src/config/config";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { helpingVideoAgainstCategory } from "src/DAL/HelpingVideos/AdminHelpingVideos";
import RecordNotFound from "src/components/GeneralComponents/RecordNotFound";
import { useQuery } from "@tanstack/react-query";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function HelpingVideos() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const { data: adminVideos = [], isLoading } = useQuery({
    queryKey: ["helpingVideos", id],
    queryFn: async () => {
      const postData = {
        search: "",
      };
      const result = await helpingVideoAgainstCategory(postData, id);
      if (result?.code !== 200) {
        throw new Error(result?.message);
      }
      return result;
    },
    select: (result) => result?.helping_videos || [],
    onError: (error) => {
      enqueueSnackbar(error?.message, { variant: "error" });
    },
  });

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
  return (
    <div className="container-fluid">
      <div className="row mobile-margin display-flex">
        <div className="col-12">
          <IconButton
            className="back-screen-button"
            onClick={() => navigate(-1)}
          >
            <ArrowBackIcon />
          </IconButton>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-sm-12">
          <h2>Helping videos </h2>
        </div>

        {adminVideos.length > 0 ? (
          adminVideos.map((value, index) => {
            return (
              <div className="col-lg-4 col-md-4 col-sm-12 mb-4" key={index}>
                <div
                  className="card mt-4 pods-cards-shadow cursor h-100"
                  onClick={() =>
                    navigate(
                      `/helping_videos_category/${id}/helping-videos/${value.helping_video_slug}`,
                      {
                        state: value,
                      },
                    )
                  }
                >
                  <img
                    src={s3baseUrl + value.thumbnail_image.thumbnail_1}
                    className="card-img-top pods-image"
                    alt="image"
                  />
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12">
                        <h3 className="h2-heading">{value.title}</h3>
                      </div>

                      <div className="col-2 menu-option"></div>
                    </div>
                    <p className="programme-card-desc">
                      {value.short_description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <RecordNotFound title="Videos" />
        )}
      </div>
    </div>
  );
}
